import React, { useState } from "react";
import moment from "moment";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import HomeAddresses from "../pipeline/HomeAddresses";
import HomeApplicants from "../pipeline/HomeApplicants";
import ExpandDiv from "../common/ExpandDiv";

function FosterHomeButtonBar({ home }) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedBed, setSelectedBed] = useState("");
  const [rand, setRand] = useState(Math.floor(Math.random() * 10));

  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));

  const bedData = [
    {
      beds: [
        {
          id: "668fdfb53deeef47f0c276d1",
          gender: "all",
          history: [
            {
              contact: "Mckinney Rivera",
              admit: "2022-09-16T01:17:53.311Z",
              discharge: "2024-07-12T13:35:49.873Z",
              status: "Occupied",
            },
            {
              contact: "Osborne Atkinson",
              admit: "2023-02-15T05:50:47.973Z",
              discharge: null,
              status: "Discharged",
            },
            {
              contact: "Shannon Barry",
              admit: "2023-10-16T09:55:30.589Z",
              discharge: null,
              status: "Discharged",
            },
            {
              contact: "Kristy Charles",
              admit: "2023-07-23T22:05:04.372Z",
              discharge: null,
              status: "Discharged",
            },
          ],
        },
        {
          id: "668fdfb5b2fe346fc282fd55",
          gender: "male",
          history: [
            {
              contact: null,
              admit: null,
              discharge: null,
            },
            {
              contact: "Madelyn Oconnor",
              admit: "2022-07-03T03:03:35.875Z",
              discharge: "2024-07-12T13:35:49.876Z",
              status: "Discharged",
            },
          ],
        },
        {
          id: "668fdfb5fec203037ceada3e",
          gender: "all",
          history: [],
        },
      ],
    },
    {
      beds: [
        {
          id: "668fdfb5814313d8ed16142b",
          gender: "female",
          history: [
            {
              contact: "Mari Mccoy",
              admit: "2023-02-05T23:33:11.111Z",
              discharge: "2024-07-12T13:35:49.876Z",
              status: "Occupied",
            },
            {
              contact: "Summer Tyler",
              admit: "2022-01-31T03:29:19.318Z",
              discharge: null,
              status: "Discharged",
            },
            {
              contact: "Maddox Kirkland",
              admit: "2022-10-02T02:49:48.664Z",
              discharge: null,
              status: "Discharged",
            },
            {
              contact: "Chrystal Gonzales",
              admit: "2023-04-08T10:50:58.882Z",
              discharge: null,
              status: "Discharged",
            },
            {
              contact: "Walton Stokes",
              admit: "2022-03-19T10:07:48.227Z",
              discharge: null,
              status: "Discharged",
            },
          ],
        },
      ],
    },
    {
      beds: [
        {
          id: "668fdfb50e6824a6005f1d44",
          gender: "female",
          history: [
            {
              contact: "Jaime Knapp",
              admit: "2022-09-15T06:10:21.794Z",
              discharge: "2024-07-12T13:35:49.876Z",
              status: "Double Paid Respite",
            },
          ],
        },
        {
          id: "668fdfb50f1d37185980235e",
          gender: "female",
          history: [
            {
              contact: "Finley Walters",
              admit: "2023-06-15T05:16:48.652Z",
              discharge: "2024-07-12T13:35:49.876Z",
              status: "Unpaid Leave",
            },
            {
              contact: "Olson Suarez",
              admit: "2022-06-27T16:30:37.417Z",
              discharge: null,
              status: "Discharged",
            },
            {
              contact: "Shelby Ortiz",
              admit: "2022-06-16T02:35:29.051Z",
              discharge: "2024-07-12T13:35:49.876Z",
              status: "Discharged",
            },
          ],
        },
        {
          id: "668fdfb5feadae06291a6b03",
          gender: "male",
          history: [
            {
              contact: null,
              admit: null,
              discharge: null,
            },
          ],
        },
      ],
    },
    {
      beds: [
        {
          id: "668fdfb5fd9b6b46938ab67e",
          gender: "female",
          history: [],
        },
      ],
    },
    {
      beds: [
        {
          id: "668fdfb53f4b0ee232315f46",
          gender: "female",
          history: [
            {
              contact: "Lola Chandler",
              admit: "2023-10-25T15:13:43.347Z",
              discharge: null,
              status: "Paid Leave",
            },
            {
              contact: "Neal Berry",
              admit: "2023-08-14T05:59:31.518Z",
              discharge: "2024-07-12T13:35:49.877Z",
              status: "Discharged",
            },
          ],
        },
      ],
    },
    {
      beds: [
        {
          id: "668fdfb56ab64e1ee24247e1",
          gender: "female",
          history: [
            {
              contact: null,
              admit: null,
              discharge: null,
            },
          ],
        },
      ],
    },
    {
      beds: [
        {
          id: "668fdfb5051a523da8161d7d",
          gender: "male",
          history: [],
        },
        {
          id: "668fdfb53840d1a6775c7ffa",
          gender: "female",
          history: [],
        },
        {
          id: "668fdfb5b455e0ee666b6ff8",
          gender: "all",
          history: [
            {
              contact: "Krystal Dominguez",
              admit: "2022-05-24T09:41:59.923Z",
              discharge: null,
              status: "Discharged",
            },
            {
              contact: "Williamson Price",
              admit: "2023-06-08T19:23:08.744Z",
              discharge: null,
              status: "Discharged",
            },
            {
              contact: "Donaldson Savage",
              admit: "2023-12-09T17:36:29.249Z",
              discharge: "2024-07-12T13:35:49.877Z",
              status: "Discharged",
            },
            {
              contact: "Rasmussen Meadows",
              admit: "2022-10-07T11:02:33.887Z",
              discharge: null,
              status: "Discharged",
            },
          ],
        },
      ],
    },
    {
      beds: [
        {
          id: "668fdfb55c88ccb65e707376",
          gender: "male",
          history: [
            {
              contact: "Whitfield Monroe",
              admit: "2023-11-07T11:34:13.214Z",
              discharge: "2024-07-12T13:35:49.877Z",
              status: "Occupied",
            },
          ],
        },
        {
          id: "668fdfb5fe403ac7bb5b6298",
          gender: "male",
          history: [
            {
              contact: "Beatrice Ware",
              admit: "2023-05-11T09:55:01.145Z",
              discharge: null,
              status: "Occupied",
            },
            {
              contact: "Lorene Hebert",
              admit: "2022-03-05T00:43:57.767Z",
              discharge: "2024-07-12T13:35:49.877Z",
              status: "Discharged",
            },
          ],
        },
      ],
    },
    {
      beds: [
        {
          id: "668fdfb574481ec482842ffa",
          gender: "all",
          history: [],
        },
        {
          id: "668fdfb50b752af78caa1dde",
          gender: "female",
          history: [],
        },
      ],
    },
    {
      beds: [
        {
          id: "668fdfb51c6417c2052f6a80",
          gender: "all",
          history: [
            {
              contact: "Kirkland Schroeder",
              admit: "2023-10-03T20:55:53.144Z",
              discharge: null,
              status: "Respite",
            },
            {
              contact: "Kerr Hudson",
              admit: "2022-12-03T02:51:06.451Z",
              discharge: null,
              status: "Discharged",
            },
            {
              contact: "Leanne Whitley",
              admit: "2022-07-10T15:42:44.064Z",
              discharge: null,
              status: "Discharged",
            },
          ],
        },
      ],
    },
  ];
  return (
    <React.Fragment key={home.id}>
      <Modal
        size="xl"
        show={isOpen}
        animation={false}
        onHide={() => setIsOpen(false)}
      >
        <Modal.Header closeButton className="bg-safy-info text-white">
          <Modal.Title>{home.id}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {home.HomeData.length > 0 ? (
            <div className="border rounded mb-2 p-2">
              <div className="fw-bold mb-4">
                <button
                  className="btn btn-primary"
                  onClick={() =>
                    window.open(
                      `https://family.binti.com/admin/applications/${home.HomeData[0].applicationid}`
                    )
                  }
                >
                  Open in Binti
                </button>
                <button className="btn btn-info ms-2">Add a Bed</button>
              </div>
              {safyInfo?.user?.modules?.includes("Admin") ? (
                <div className="rounded border border-dark p-1 mb-4">
                  <div className="bg-warning rounded p-2 fw-bold mb-2">
                    Admin
                  </div>
                  <button className="btn btn-success mb-2">
                    Set up as new Foster Home
                  </button>
                  <div className="row">
                    <div className="col">Azure ID</div>
                    <div className="col">XXX</div>
                    <div className="col">XXX</div>
                  </div>
                  <div className="row">
                    <div className="col">CRM User</div>
                    <div className="col">xxx</div>
                    <div className="col">xxx</div>
                  </div>
                  <div className="row">
                    <div className="col">CRM Contact</div>
                    <div className="col">xxx</div>
                    <div className="col">xxx</div>
                  </div>
                  <div className="row">
                    <div className="col">SAGE ID</div>
                    <div className="col">xxxx</div>
                    <div className="col">xxxx</div>
                  </div>
                </div>
              ) : null}
              <ExpandDiv
                className="border rounded bg-light p-1 m-1 fw-normal"
                title="Binti Application History"
              >
                {home.HomeData.map((b, index) => (
                  <ExpandDiv
                    className="border rounded bg-light p-1 m-1 fw-normal"
                    title={`${b.type} (${b.status}${
                      b.statusdate
                        ? ` ${new Date(b.statusdate).toLocaleDateString()}`
                        : ""
                    })`}
                    expandStatus={index === 0 ? "expanded" : null}
                    key={`${b.homeid}${index}`}
                  >
                    <div className="mb-2 text-dark">
                      <div className="row mb-2 mx-2">
                        <div className="col">Status</div>
                        <div className="col fw-bold">{b.status}</div>
                        <div className="col">Status Date</div>
                        {b.statusdate ? (
                          <div className="col fw-bold">
                            {new Date(b.statusdate).toLocaleDateString()}
                          </div>
                        ) : (
                          <div className="col"></div>
                        )}
                      </div>
                      <div className="row mb-2 mx-2">
                        <div className="col">Capacity</div>
                        <div className="col fw-bold">
                          {b.capacity ? b.capacity : null}
                        </div>
                        <div className="col">Renewal Due Date</div>
                        <div className="col fw-bold">
                          {b.renewaldate
                            ? new Date(b.renewaldate).toLocaleDateString()
                            : null}
                        </div>
                      </div>
                      <div className="row mb-2 mx-2">
                        <div className="col">
                          {b?.approvedagelower ? "Ages" : null}
                        </div>
                        <div className="col fw-bold">
                          {b.approvedagelower
                            ? `${b.approvedagelower}-${b.approvedagehigher}`
                            : null}
                        </div>
                        <div className="col">Inquiry Date</div>
                        <div className="col fw-bold">
                          {b.inquirydate
                            ? new Date(b.inquirydate).toLocaleDateString()
                            : null}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col">
                          <div className="mb-1 mx-4 fw-bold">Workers</div>
                          <div className="mb-2 mx-4">
                            {JSON.stringify(b.workers) !== "[{}]" &&
                              b.workers.map((w, index) => (
                                <div key={`${w.id}-${index}`} className="mx-2">
                                  {w.worker_name}
                                </div>
                              ))}
                          </div>
                        </div>
                        <div className="col"></div>
                        <div className="col">home ID</div>
                        <div className="col">{b.homeid}</div>
                      </div>
                    </div>
                  </ExpandDiv>
                ))}
              </ExpandDiv>
            </div>
          ) : null}
        </Modal.Body>
      </Modal>
      <Modal
        size="xl"
        show={selectedBed !== ""}
        animation={false}
        onHide={() => setSelectedBed("")}
      >
        <Modal.Header closeButton className="bg-safy-info text-white">
          <Modal.Title>{selectedBed.bedName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-3">Client</div>
            <div className="col-2">Admit</div>
            <div className="col-2">Discharge</div>
            <div className="col-2">Last Status</div>
          </div>

          {selectedBed?.history?.map((h, index) => (
            <div
              key={`${selectedBed.id}${index}`}
              className={`row rounded border border-dark p-1 mb-2 ${
                h.contact ? "bg-info" : "bg-success text-white"
              }`}
            >
              <div className="col-3">
                <i
                  className="fas fa-user pe-2"
                  role="button"
                  onClick={() =>
                    toast.success("This would open up the contact record")
                  }
                />
                {h.contact ? h.contact : "Unoccupied"}
              </div>
              <div className="col-2">
                {h.admit ? moment(h.admit).format("MM/D/YY") : null}
              </div>
              <div className="col-2">
                {h.discharge ? moment(h.discharge).format("MM/D/YY") : null}
              </div>
              <div className="col-2">{h.status}</div>
              <div className="col-3 bg-white rounded py-1">
                <i
                  className="fas fa-calendar-days fa-xl me-1 "
                  role="button"
                  title="Daily Services"
                />
                {index === 0 ? (
                  <>
                    <i
                      className="fas fa-calendar-minus fa-xl me-1 text-warning "
                      role="button"
                      title="Respite"
                    />
                    <i
                      className="fas fa-calendar-xmark fa-xl me-1 text-danger"
                      role="button"
                      title="Discharge"
                    />
                  </>
                ) : null}
              </div>
            </div>
          ))}
        </Modal.Body>
      </Modal>
      <div className="row rounded border border-dark mb-2 p-2">
        <div className="row">
          <div className="col-1 text-safy-info">
            <div className="p-1">
              <i
                className="fas fa-home fa-lg"
                role="button"
                title="Open Home"
                onClick={() => {
                  setIsOpen(!isOpen);
                }}
              ></i>
            </div>
            <div className="p-1">
              <HomeAddresses application={home} />
            </div>
          </div>
          <div className="col-3">
            <HomeApplicants application={home} />
          </div>
          <div className="col-5">
            <div className="row">
              <div className="col-3">Capacity</div>
              <div className="col-9 fw-bold">{home.HomeData[0].capacity}</div>
            </div>
            <div className="row">
              <div className="col-3">Ages</div>
              <div className="col-9 fw-bold">
                {home.HomeData[0].approvedagelower
                  ? `${home.HomeData[0].approvedagelower}-${home.HomeData[0].approvedagehigher}`
                  : null}
              </div>
            </div>
          </div>
          <div className="col-3">
            {bedData[rand].beds.map((bed, index) => (
              <div
                key={bed.id}
                className={`rounded border border-dark mb-1 row bg-info`}
                title={`Admit: ${moment(bed.history[0]?.admit).format(
                  "MM/D/YY"
                )} - Discharge: ${moment(bed.history[0]?.discharge).format(
                  "MM/D/YY"
                )}`}
              >
                <div className="col-3 pt-1">
                  <i
                    className="fas fa-bed pe-1"
                    role="button"
                    onClick={() => {
                      setSelectedBed({ ...bed, bedName: `Bed ${index + 1}` });
                    }}
                  />
                  {` ${index + 1} `}
                </div>
                <div className="col-9">
                  {bed.history[0]?.contact ? (
                    <div
                      className="rounded bg-light my-1 d-flex"
                      role="button"
                      onClick={() =>
                        toast.success("This would open to contact record")
                      }
                    >
                      <div
                        className="rounded border bg-warning px-1 fw-bold"
                        title={bed.history[0].status}
                      >
                        {bed.history[0].status.match(/\b(\w)/g).join("")}
                      </div>
                      <i className="fas fa-person mx-1 pt-1" />{" "}
                      {bed.history[0].contact}
                    </div>
                  ) : (
                    <div className="rounded bg-success text-white m-1 ps-2">
                      Unoccupied
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="row mt-2 ms-2 text-safy-info"></div>
      </div>
    </React.Fragment>
  );
}

export default FosterHomeButtonBar;
